"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateStateByData = exports.generateInitialState = exports.shuffleArray = exports.getCurrentLanguage = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const getCurrentLanguage = () => {
    return js_cookie_1.default.get("lang_id");
};
exports.getCurrentLanguage = getCurrentLanguage;
const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = 0; i < newArray.length; i++) {
        const j = Math.floor(Math.random() * (i + 1)); // Генерируем случайный индекс
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]]; // Меняем местами элементы
    }
    return newArray;
};
exports.shuffleArray = shuffleArray;
const generateInitialState = (length) => {
    return Array.from({ length }, (_, index) => ({
        isCorrect: false,
        index: index + 1,
        isChecked: false
    }));
};
exports.generateInitialState = generateInitialState;
// должно быть вместо generateInitialState disinhibitions
const generateStateByData = (items) => items.map(item => ({
    id: item.id,
    isChecked: false,
    isCorrect: false
}));
exports.generateStateByData = generateStateByData;
